<!-- basic template for most components -->
<template>
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{ path: '/' }">
      <img src="https://test.jeffersoncountyoh.com/static/images/friendship/Fship_logo.svg" class="image-flex mr-3" style="width: 40px;" />
      Friendship Park
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">

      <!-- links start here -->
      <b-navbar-nav>
      
        <!-- online services ======================================= -->
        <b-nav-item-dropdown text="Online Services" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons" style="padding-right: 4px;">info</i>
            <span class="align-top">Park Info</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/history' }">Park History</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/board' }">Park Board</b-dropdown-item>

        </b-nav-item-dropdown>

        <!-- county offices ======================================= -->
        <b-nav-item-dropdown text="County Offices" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons" style="padding-right: 4px;">place</i>
            <span class="align-top">Attractions</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/activities' }">Park Activities</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/campgrounds' }">Campgrounds</b-dropdown-item>

        </b-nav-item-dropdown>

        <!-- county courts ======================================= -->
        <b-nav-item-dropdown text="County Courts" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons" style="padding-right: 4px;">list_alt</i>
            <span class="align-top">Regulations</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/rules/park' }">Park Rules</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/rules/camping' }">Camping Rules</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/rules/fishing' }">Fishing Rules</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/rules/hunting' }">Hunting Rules</b-dropdown-item>

        </b-nav-item-dropdown>

        <!-- county info ======================================= -->
        <b-nav-item-dropdown text="County Info" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons" style="padding-right: 4px;">label</i>
            <span class="align-top">Links of Interest</span>
          </template>
          
          <b-dropdown-item href="https://www.jeffersoncountychamber.com/">Chamber of Commerce</b-dropdown-item>
          <b-dropdown-item href="http://www.jeffersoncntyfair.com/">Jefferson County Fair</b-dropdown-item>
          <b-dropdown-item href="https://www.facebook.com/Freebird-Dragway-164445410967914/">Freebird Dragway</b-dropdown-item>
          <b-dropdown-item href="https://nssdc.gsfc.nasa.gov/planetary/lunar/moon_trees/friendship_park_tree.html#:~:text=Moon%20Seedling%20Planted,1%20shelterhouse">Friendship Park Moon Tree</b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- <b-nav-item class="text-danger" href="#">Plain link</b-nav-item> -->

      </b-navbar-nav>
      <!-- links end -->

    </b-collapse>
  </b-navbar>
</template>

<script>

import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar'
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav'
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand'
import bNavbarToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle'
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item'  
import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown'

export default {
    components: {
    bCollapse,
    bDropdownItem,
    bNavbar,
    bNavbarNav,
    bNavbarBrand,
    bNavbarToggle,
    bNavItem,
    bNavItemDropdown
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style>
</style>
